// Predator Standings
export const standingsTypes = [
	"Cumulatif", 
	"Lancement: L'Abasie (Neufchâtel / Valleyfield)",
	"Stop #1: Dooly's St-Hyacinthe",
];

export const standings_reg = [[
["Danny Hewitt", 28],
["Francis Crevier", 28],
["Sylvain Gingras", 23],
["Vincent Beaurivage", 22],
["Tommy Cayer", 21],
["Alain Martel", 20],
["Harold Rousseau", 18],
["Dany Normandin", 16],
["Yves Gaudreault", 16],
["Martin Daigle", 16.00001],
["Elvis Joubert", 14],
["Simon Boucher", 13],
["Tom Tériault", 13],
["Éric Laplante", 11],
["Mehdi Bahloul", 11],
["David Blanchet", 10],
["Jonathan Gauvreau", 10],
["René Brind'Amour", 10],
["Sébastien Laramée", 10],
["Myriam Lafranchise", 10],
["Éric Duschesneau", 10],
["Dany Nguyen", 9],
["Denys Zbikowski", 9],
["Denys Zbikowski", 9],
["Martin Sears", 8],
["Stéphane Pouliot", 8],
["Guillaume McNicoll", 8],
["Yvan Simard", 8],
["Dave Simard", 7],
["Ryan Maclaurin", 7],
["Jonathan Bourdages", 7],
["Jeff Blais", 7],
["David Lanthier", 7],
["Marie-France Blanchette", 7],
["Hakim Racicot", 7],
["Éric Cloutier", 6],
["Mathieu Ouellet", 6],
["Dany Guay", 6],
["Claude Larouche", 6],
["Danny Rioux", 6],
["Brad Guthrie", 6],
["Jean Vaillancourt", 6],
["Dominic Gauthier", 5],
["Francis English", 5],
["Luc Leduc", 5],
["Marco Caron", 5],
["Pascal St-Amand", 5],
["Patrick Williams", 5],
["Alain Losier", 5],
["Steeve Bouchard", 5],
["Sébastien Belley", 5],
["Sébastien Binette", 5],
["Marc Malette", 5],
["Patrick Bernardi", 5],
["Kenny Donald", 5],
["Luc Marion", 5],
["Jonathan Bélanger", 4],
["Simon Robitaille", 4],
["André Pelletier", 4],
["Denis Néron", 4],
["Richard Couillard", 4],
["Daniel Laramée", 4],
["Marc-André Haineault", 4],
["Arnaud Rakovich", 4],
["Chantal Bergeron", 4],
["Jean-Guy Carignan", 4],
["Karl Tremblay", 4],
["Jean-Daniel Dumais", 3],
["Marco Sanschagrin", 3],
["Louis-Bertin Michel", 3],
["Jean-Luc Martel", 3],
["Jonathan Barbarie", 3],
["Michael Boulianne", 3],
["Michel Renaud", 3],
["Shawn Labranche", 3],
],
[
["Danny Hewitt", "F-1", 16],
["Francis Crevier", "F-2", 15],
["Sylvain Gingras", "F-3", 14],
["Tom Tériault", "F-4", 13],
["Alain Martel", "F-5", 12],
["Martin Daigle", "F-5", 12],
["Tommy Cayer", "F-7", 11],
["Vincent Beaurivage", "F-7", 11],
["Dany Normandin", "F-9", 10],
["Jonathan Gauvreau", "F-9", 10],
["René Brind'Amour", "F-9", 10],
["Sébastien Laramée", "F-9", 10],
["Dany Nguyen", "F-13", 9],
["Yves Gaudreault", "F-13", 9],
["Denys Zbikowski", "F-13", 9],
["Elvis Joubert", "F-13", 9],
["Harold Rousseau", "F-13", 9],
["Stéphane Pouliot", "Q-17", 8],
["Guillaume McNicoll", "Q-17", 8],
["Mehdi Bahloul", "Q-17", 8],
["Jonathan Bourdages", "Q-21", 7],
["Jeff Blais", "Q-21", 7],
["Myriam Lafranchise", "Q-21", 7],
["David Lanthier", "Q-21", 7],
["Dany Guay", "Q-25", 6],
["Claude Larouche", "Q-25", 6],
["Éric Laplante", "Q-25", 6],
["Danny Rioux", "Q-25", 6],
["Brad Guthrie", "Q-25", 6],
["Éric Duschesneau", "Q-25", 6],
["Simon Boucher", "Q-25", 6],
["Jean Vaillancourt", "Q-25", 6],
["Alain Losier", "Q-33", 5],
["Steeve Bouchard", "Q-33", 5],
["Sébastien Belley", "Q-33", 5],
["Sébastien Binette", "Q-33", 5],
["Marc Malette", "Q-33", 5],
["Patrick Bernardi", "Q-33", 5],
["Kenny Donald", "Q-33", 5],
["Luc Marion", "Q-33", 5],
["Jonathan Bélanger", "Q-41", 4],
["Simon Robitaille", "Q-41", 4],
["André Pelletier", "Q-41", 4],
["Denis Néron", "Q-41", 4],
["Richard Couillard", "Q-41", 4],
["Yvan Simard", "Q-41", 4],
["Daniel Laramée", "Q-41", 4],
["Marie-France Blanchette", "Q-41", 4],
["David Blanchet", "Q-41", 4],
["Marc-André Haineault", "Q-41", 4],
["Jean-Daniel Dumais", "Q-51", 3],
["Marco Sanschagrin", "Q-51", 3],
["Hakim Racicot", "Q-51", 3],
["Louis-Bertin Michel", "Q-51", 3],
], 
[
["Francis Crevier", 1, 13],
["Danny Hewitt", 2, 12],
["Vincent Beaurivage", 3, 11],
["Tommy Cayer", 4, 10],
["Sylvain Gingras", 5, 9],
["Harold Rousseau", 5, 9],
["Alain Martel", 7, 8],
["Martin Sears", 7, 8],
["Dave Simard", 9, 7],
["Ryan Maclaurin", 9, 7],
["Simon Boucher", 9, 7],
["Yves Gaudreault", 9, 7],
["Dany Normandin", 13, 6],
["David Blanchet", 13, 6],
["Éric Cloutier", 13, 6],
["Mathieu Ouellet", 13, 6],
["Dominic Gauthier", 17, 5],
["Elvis Joubert", 17, 5],
["Éric Laplante", 17, 5],
["Francis English", 17, 5],
["Luc Leduc", 17, 5],
["Marco Caron", 17, 5],
["Pascal St-Amand", 17, 5],
["Patrick Williams", 17, 5],
["Arnaud Rakovich", 25, 4],
["Chantal Bergeron", 25, 4],
["Éric Duschesneau", 25, 4],
["Hakim Racicot", 25, 4],
["Jean-Guy Carignan", 25, 4],
["Karl Tremblay", 25, 4],
["Martin Daigle", 25, 4],
["Yvan Simard", 25, 4],
["Jean-Luc Martel", 33, 3],
["Jonathan Barbarie", 33, 3],
["Marie-France Blanchette", 33, 3],
["Mehdi Bahloul", 33, 3],
["Michael Boulianne", 33, 3],
["Michel Renaud", 33, 3],
["Myriam Lafranchise", 33, 3],
["Shawn Labranche", 33, 3],
]];

export const standings_2ndCh = [[
["Marie-France Blanchette", 7, 3, 10],
["Steeve Bouchard", 6, 3, 9],
["Chantal Bergeron", 6, 3, 9],
["Michael Boulianne", 6, 3, 9],
["Jonathan Bourdages", 5, 3, 8],
["Pascal St-Amand", 5, 3, 8],
["André Pelletier", 4, 3, 7],
["Marc-Andre Haineault", 4, 3, 7],
["Louis-Bertin Michel", 3, 3, 6],
["Alain Losier", 2, 3, 5],
["Marc Malette", 2, 3, 5],
["Denis Néron", 2, 3, 5],
["Marco Caron", 2, 3, 5],
["Sébastien Belley", 1, 3, 4],
["Simon Chapadeau", 4, 0, 4],
["Elvis Joubert", 1, 3, 4],
["Éric Cloutier", 1, 3, 4],
["Michel Renaud", 1, 3, 4],
["René Boissonnault", 3, 0, 3],
["Pierre Jubinville", 2, 0, 2],
["Sandra Mackay", 1, 0, 1],
["Karl Pétrin", 1, 0, 1],
],
[
["Steeve Bouchard", 1, 6, 3, 9],
["Jonathan Bourdages", 2, 5, 3, 8],
["André Pelletier", 3, 4, 3, 7],
["Louis-Bertin Michel", 4, 3, 3, 6],
["Alain Losier", 5, 2, 3, 5],
["Denis Néron", 5, 2, 3, 5],
["Sébastien Belley", 7, 1, 3, 4],
["Marc-Andre Haineault", 1, 4, 3, 7],
["Chantal Bergeron", 2, 3, 0, 3],
["Marc Malette", 3, 2, 3, 5],
["Sandra Mackay", 4, 1, 0, 1],
], 
[
["Marie-France Blanchette", 1, 7, 3, 10],
["Michael Boulianne", 2, 6, 3, 9],
["Pascal St-Amand", 3, 5, 3, 8],
["Simon Chapadeau", 4, 4, 0, 4],
["Chantal Bergeron", 5, 3, 3, 6],
["René Boissonnault", 5, 3, 0, 3],
["Marco Caron", 7, 2, 3, 5],
["Pierre Jubinville", 7, 2, 0, 2],
["Elvis Joubert", 9, 1, 3, 4],
["Éric Cloutier", 9, 1, 3, 4],
["Karl Pétrin", 9, 1, 0, 1],
["Michel Renaud", 9, 1, 3, 4],
]];
